/*-------------------------------------------------------------------------------------------------------------------
* about:设备名称的选择
* author:马兆铿
* date:2018-1-11
* -------------------------------------------------------------------------------------------------------------------*/
import {getDevAliaslist, getDevInfo, updateDevInfo} from "../../../../api/index"
import {getQueryString} from '../../../../utils/url'
import {checkIfSupportPlugName, isCanChangeNameDevice, plugList} from '../../../../utils/device/deviceName'

/*  选择设备名字
* */
class SelectDeviceName {
  /*  数据列表获取
  * */
  getList() {
    return new Promise((resolve, reject) => {
      let list = []
      getDevInfo({
        token: sessionStorage.getItem("token"),
        deviceId: getQueryString('deviceId'),
      }).then(res => {
        if (res.status !== 0) return
        let data = res.data
        getDevAliaslist().then(res => {
          if (res.success === true) {
            let key = "" // 后台数据的分类

            //根据可改名的类型，选择后台的数据列表
            const deviceType = isCanChangeNameDevice(data.deviceType)
            switch (deviceType) {
              case "light":
                key = "灯"
                break
              case "curtain":
                key = "窗帘"
                break
              case "fan":
                key = "风扇"
                break
              case "hanger":
                key = "晾衣架"
                break
              default:
                break
            }

            //插座（可以变成其它设备）是特殊的静态数据，需要看看 aligenieType 能不能对应上那些静态数据
            let plug = plugList.find(item => item.key === data.aligenieType)
            let plugName = plug && plug.value  //找到插头的应有的名字

            // 处理
            res.data.forEach((item, index) => {
              if (item.key === key) { // key同
                list = list.concat(item.value)
              }
              // 或者ali别名相同
              else if (checkIfSupportPlugName(data.deviceType) && plugName && item.key === plugName) {
                list = list.concat(item.value)
              }
            })
            resolve(list)
          } else {
            resolve([])
          }
        })
      })
    })
  }

  /*  改变
  * */
  onChangeFunction(key) {
    return new Promise((resolve, reject) => {
      updateDevInfo({
        m: "updateName",
        token: sessionStorage.getItem("token"),
        deviceId: this.$route.query.deviceId,
        name: key
      }).then(res => {
        if (res.status === 0) {
          resolve()
        } else {
          reject()
        }
      }).catch(res => {
        reject()
      })
    })
  }
}

export const selectDeviceName = new SelectDeviceName()



// WEBPACK FOOTER //
// ./src/pages/settings/Index_selection/js/deviceName.js